import dayjs from '@bunce/dayjs'
import type { CreateSMSBroadcastType } from '@bunce/schema'
import type MockUp from '~/components/MockUp.vue'

export const BROADCAST_SCHEDULE_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss'
export const BROADCAST_SCHEDULE_DISPLAY_FORMAT = 'DD MMMM, YYYY hh:mm:ss A'

export function formatBroadcastScheduleDate(
  date: Date | string,
  timezone?: string,
) {
  if (typeof date === 'string') {
    return dayjs(date, BROADCAST_SCHEDULE_DATE_FORMAT).format(
      BROADCAST_SCHEDULE_DATE_FORMAT,
    )
  }

  return timezone
    ? dayjs(date).tz(timezone).format(BROADCAST_SCHEDULE_DATE_FORMAT)
    : dayjs(date).format(BROADCAST_SCHEDULE_DATE_FORMAT)
}

export function getBroadcastScheduleCalendarDate(
  date: Date | string,
  timezone?: string,
) {
  if (typeof date === 'string' && timezone) {
    return dayjs.tz(date, BROADCAST_SCHEDULE_DATE_FORMAT, timezone).toDate()
  }

  return timezone ? dayjs(date).tz(timezone).toDate() : dayjs(date).toDate()
}

export function getBroadcastScheduleWallDate(date: Date | string) {
  return typeof date === 'string'
    ? dayjs(date, BROADCAST_SCHEDULE_DATE_FORMAT).toDate()
    : dayjs(date).toDate()
}

export function formatBroadcastScheduleDateForDisplay(
  date?: Date | string | null,
  timezone?: string,
) {
  if (!date) return ''

  return dayjs(
    formatBroadcastScheduleDate(date, timezone),
    BROADCAST_SCHEDULE_DATE_FORMAT,
  ).format(BROADCAST_SCHEDULE_DISPLAY_FORMAT)
}

export function smsMockUpPreviewUpdater(
  frame: InstanceType<typeof MockUp> | null,
  values: Pick<
    CreateSMSBroadcastType,
    'message' | 'track_links' | 'include_unsubscribe_link'
  >,
) {
  if (frame) {
    const frameDocument = frame.frameElement?.contentDocument
    if (frameDocument) {
      const messageElement = frameDocument.getElementById('message')
      if (messageElement) {
        messageElement.innerText = values.message!
        if (values.track_links) {
          messageElement.innerHTML = messageElement.innerText.replace(
            /(https?:\/\/)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@;:%_+.~#?&\/=]*)/g,
            '<span style="text-decoration: underline; font-style: italic;">www.bunce.link/sample</span>',
          )
        }
        frameDocument.getElementById('unsubscribeLink')!.style.display =
          values.include_unsubscribe_link ? 'block' : 'none'
      }
    }
  }
}
